var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6667 4.6665H3.33333C2.59695 4.6665 2 5.26346 2 5.99984V11.9998C2 12.7362 2.59695 13.3332 3.33333 13.3332H12.6667C13.403 13.3332 14 12.7362 14 11.9998V5.99984C14 5.26346 13.403 4.6665 12.6667 4.6665Z",
  fill: "#94B4A4",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.33398 5.75749V4.42415C5.33398 4.07053 5.47446 3.73139 5.72451 3.48134C5.97456 3.2313 6.3137 3.09082 6.66732 3.09082H9.33398C9.6876 3.09082 10.0267 3.2313 10.2768 3.48134C10.5268 3.73139 10.6673 4.07053 10.6673 4.42415V5.75749",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.33398 5.75749V4.42415C5.33398 4.07053 5.47446 3.73139 5.72451 3.48134C5.97456 3.2313 6.3137 3.09082 6.66732 3.09082H9.33398C9.6876 3.09082 10.0267 3.2313 10.2768 3.48134C10.5268 3.73139 10.6673 4.07053 10.6673 4.42415V5.75749",
  stroke: "#94B4A4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8 8V8.00808",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2 8.6665C3.86105 9.6043 5.91602 10.0928 8 10.0928C10.084 10.0928 12.1389 9.6043 14 8.6665",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgWorkplaceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplaceIcon);
export default __webpack_public_path__ + "static/media/workplace-icon.8c46a61b624d1cdd7408f3ed5334391d.svg";
export { ForwardRef as ReactComponent };